module.exports = __webpack_public_path__ + "static/media/16_zemly_0_89.91.bfe13006.png";